<template>
  <div class="widget" :class="{light: light, show: show}">
    <div class="widget__up" v-scroll-to="'#letters'"><span>Наверх</span></div>
    <div class="widget__button">
      <a href="https://kion.onelink.me/aJR1?pid=dcm_media&is_retargeting=true&af_click_lookback=30d&af_dp=https%3A%2F%2Fkion.ru%2Fvideo%2Fserial%2F414221777%2Fseason%2F414220180%2Fepisode%2F414224945&af_web_dp=https%3A%2F%2Fkion.ru%2Fvideo%2Fserial%2F414221777%2Fseason%2F414220180%2Fepisode%2F414224945%3Futm_source%3D7days%26utm_medium%3Darticle%26utm_campaign%3Dvertinskij_414221777_q3_2021_abc%26utm_term%3Darticle_c_web_mob_int_article_rf_%26utm_content%3Dspecial&c=vertinskij_414221777_q3_2021_abc&af_adset=7days_article_article_c_web_mob_int_article_rf_special&af_sub1=https%253A%252F%252Fkion.ru%252Fvideo%252Fserial%252F414221777%252Fseason%252F414220180%252Fepisode%252F414224945" target="_blank">Смотреть сериал</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Widget',
  data() {
    return {
      light: false,
      show: false,
    }
  },
  created () {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll () {
      let fullH = document.documentElement.getBoundingClientRect().height;
      let topH = window.pageYOffset;
      let procentScroll = topH/fullH*100;
      if (window.innerWidth > 1000) {
        console.log(procentScroll);
        if (procentScroll > 4 && procentScroll < 92) {
          this.show = true;
        } else {
          this.show = false;
        }
        if (procentScroll > 15.2 && procentScroll < 64.4) {
          this.light = true;
        } else {
          this.light = false;
        }
        if (procentScroll > 83 && procentScroll < 100) {
          this.light = true;
        }
      }
    }
  },
}
</script>

<style lang="sass">
  .widget
    position: fixed
    z-index: 9999
    text-align: center
    bottom: vw(17px)
    right: vw(-317px)
    transition: all 300ms
    &.show
      right: vw(17px)
    &__up
      color: #000
      text-transform: uppercase
      font-size: vw(16px)
      margin-bottom: vw(10px)
      cursor: pointer
      span
        &:after
          width: vw(71px)
          height: 1px
          margin: auto
          background-color: #000
          content: ''
          display: block
    &__button
      a
        display: block
        width: vw(105px)
        height: vw(105px)
        background-color: #000
        color: #fff
        text-decoration: none
        display: flex
        align-items: center
        text-align: center
        border-radius: 50%
        font-size: vw(16px)
        line-height: vw(18px)
        cursor: pointer
        position: relative
        transform: scale(1)
        transition: all 300ms
        animation: pulse-black 2s infinite
        &:hover
          background-color: #740D0C !important
        &:after
          content: ''
          display: block
          width: vw(96px)
          height: vw(96px)
          border: 1px solid #Fff
          position: absolute
          top: 0
          bottom: 0
          left: 0
          right: 0
          margin: auto
          border-radius: 50%
    &.light
      .widget__up
        color: #fff
        span
          &:after
            background-color: #fff !important
      .widget__button a 
        background-color: #fff
        color: #000
        animation: pulse-white 2s infinite
        &:hover
          color: #fff !important
          &:after
            border-color: #fff !important
        &:after
          border-color: #000
  @keyframes pulse-black 
    0% 
      box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.7)
    70% 
      box-shadow: 0 0 0 vw(10px) rgba(0, 0, 0, 0)
    100% 
      box-shadow: 0 0 0 0 rgba(0, 0, 0, 0)
  @keyframes pulse-white 
    0% 
      box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.7)
    70% 
      box-shadow: 0 0 0 vw(10px) rgba(255, 255, 255, 0)
    100% 
      box-shadow: 0 0 0 0 rgba(255, 255, 255, 0)
</style>
